import { supabase } from "./supabase";

// Pede o parecer da IA sobre um contato registrado.
//
// Nunca quebra a tela: qualquer falha volta como { ok:false, erro } para o
// gerente ler e seguir conferindo na mão. O parecer é ajuda, não dependência.

export async function analisarAbordagem(parceiroId, ref) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;
    if (!token) return { ok: false, erro: "Sessão expirada — entre de novo." };

    const r = await fetch("/api/analisar-abordagem", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ parceiroId, ref }),
    });
    const j = await r.json().catch(() => ({}));
    if (!j?.ok) return { ok: false, erro: j?.erro || "Não consegui analisar agora." };
    return j;
  } catch (e) {
    return { ok: false, erro: "Falha de conexão ao pedir a análise." };
  }
}

export const CORES_QUALIDADE = { bom: "#059669", ok: "#d97706", fraco: "#dc2626" };

/** Frase curta para o cabeçalho do parecer. */
export function resumoCurto(a) {
  if (!a) return "";
  if (a.eh_conversa === false) return "O comprovante não mostra uma conversa";
  if (a.houve_resposta === false) return "Mensagem enviada, sem resposta do fornecedor";
  if (a.houve_resposta === true) return "Conversa com resposta do fornecedor";
  return "Conversa registrada";
}
